import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';

export interface IDistributionRule {
    distributionId: string;
    brand: string;
    ruleName: string;
    createdBy: string;
    dateCreated: string;
    dateModified: string;
    country: string;
}

export interface IDistributionRuleDetails extends IDistributionRule {
    modifiedBy?: string;
    states?: Array<string | number>;
    regions?: Array<string | number>;
    districts?: Array<string | number>;
    dealers?: Array<string | number>;
}

/** `deleted: false` on a 200 means the rule is still linked to an active bulletin or critical organization update. */
export interface IDeleteDistributionRuleResponse {
    deleted: boolean;
}

export class DistributionRuleService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };

    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    public async getAllDistributionRules(): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/getAllDistributionRules`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                jwtToken: permissionsToken,
            },
        };

        return this.client.sendRequest(request);
    }

    public async getDistributionRuleDetails(
        distributionId: string,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/getDistributionRuleDetails`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                distributionId,
                jwtToken: permissionsToken,
            },
        };

        return this.client.sendRequest(request);
    }

    public async deleteDistributionRule(
        distributionId: string,
    ): Promise<AxiosResponse<IDeleteDistributionRuleResponse>> {
        const url = `${this.dealerPortalUrlStructure}/deleteDistributionRule`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                distributionId,
                jwtToken: permissionsToken,
            },
        };

        return this.client.sendRequest(request);
    }
}
